module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'loading-styles': _vm.creatingJob || _vm.loading3JS
    }
  }, [_c('div', {
    attrs: {
      "id": "inset"
    }
  }), _vm._v(" "), (_vm.creatingJob || _vm.loading3JS) ? _c('div', {
    staticClass: "preloader",
    class: {
      'overlay': _vm.showOverlay
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "text-align": "center"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.type === "input" && !this.isSupportUploaded) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contextMenu),
      expression: "contextMenu"
    }],
    ref: "cMenu",
    staticClass: "context-menu",
    style: ({
      'top': _vm.contextMenuPosY + 'px',
      'left': _vm.contextMenuPosX + 'px'
    })
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.cMenuParallel()
      }
    }
  }, [_vm._v("Make parallel to build plate")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.loading3JS || _vm.creatingJob) && !_vm.isSupportUploaded),
      expression: "!(loading3JS || creatingJob) && !isSupportUploaded"
    }],
    attrs: {
      "id": "info"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [(!_vm.nestedMode) ? _c('span', [_vm._v("Check \"Support structures\" to generate support;")]) : _vm._e(), _vm._v("\n      Check \"Orient Model\" to scale and/or orient part.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.loading3JS || _vm.creatingJob) && !_vm.isSupportUploaded),
      expression: "!(loading3JS || creatingJob) && !isSupportUploaded"
    }],
    attrs: {
      "id": "bottom-legend"
    }
  }, [(!_vm.nestedMode) ? _c('div', {
    staticClass: "info-text"
  }, [_vm._v("To orient your part, simply grab anywhere around the part with your mouse and drag your mouse until you\n      have oriented it the way you would like. Dragging UP or DOWN will rotate the part about the screen's horizontal direction.\n      Dragging LEFT or RIGHT will rotate the part about the screen's vertical direction.")]) : _vm._e()])] : [_c('div', {
    staticClass: "bottom-block",
    class: {
      'single-legend': _vm.legends < 2
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.modifyMode) ? _c('div', {
    staticClass: "controls-box modify-supports"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Facets selection")]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.facetsSelection),
      expression: "facetsSelection"
    }],
    attrs: {
      "name": "facetsSelection",
      "type": "radio",
      "id": "restrictFace",
      "value": "restrict"
    },
    domProps: {
      "checked": _vm._q(_vm.facetsSelection, "restrict")
    },
    on: {
      "change": [function($event) {
        _vm.facetsSelection = "restrict"
      }, function($event) {
        return _vm.switchFacetSelectionMode('restrict')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "restrictFace"
    }
  }, [_vm._v("Remove Supports")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.facetsSelection),
      expression: "facetsSelection"
    }],
    attrs: {
      "name": "facetsSelection",
      "type": "radio",
      "id": "allowFace",
      "value": "allow"
    },
    domProps: {
      "checked": _vm._q(_vm.facetsSelection, "allow")
    },
    on: {
      "change": [function($event) {
        _vm.facetsSelection = "allow"
      }, function($event) {
        return _vm.switchFacetSelectionMode('allow')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "allowFace"
    }
  }, [_vm._v("Add Support Structures")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.facetsSelection),
      expression: "facetsSelection"
    }],
    attrs: {
      "name": "facetsSelection",
      "type": "radio",
      "id": "eraseFace",
      "value": "erase"
    },
    domProps: {
      "checked": _vm._q(_vm.facetsSelection, "erase")
    },
    on: {
      "change": [function($event) {
        _vm.facetsSelection = "erase"
      }, function($event) {
        return _vm.switchFacetSelectionMode('erase')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "eraseFace"
    }
  }, [_vm._v("Erase Support Modification")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brushMode),
      expression: "brushMode"
    }],
    staticClass: "filled-in",
    attrs: {
      "name": "brushMode",
      "type": "checkbox",
      "id": "brushMode"
    },
    domProps: {
      "checked": Array.isArray(_vm.brushMode) ? _vm._i(_vm.brushMode, null) > -1 : (_vm.brushMode)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.brushMode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.brushMode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.brushMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.brushMode = $$c
        }
      }, function($event) {
        return _vm.switchBrushMode()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "brushMode"
    }
  }, [_vm._v("Brush Mode")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brushBothSide),
      expression: "brushBothSide"
    }],
    staticClass: "filled-in",
    attrs: {
      "name": "brushBothSide",
      "type": "checkbox",
      "id": "brushBothSide"
    },
    domProps: {
      "checked": Array.isArray(_vm.brushBothSide) ? _vm._i(_vm.brushBothSide, null) > -1 : (_vm.brushBothSide)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.brushBothSide,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.brushBothSide = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.brushBothSide = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.brushBothSide = $$c
        }
      }, function($event) {
        return _vm.switchBrushSide()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "brushBothSide"
    }
  }, [_vm._v("Brush paints on both sides")])]), _vm._v(" "), (!_vm.brushMode) ? _c('div', {
    staticClass: "range-bar"
  }, [_c('div', {
    staticClass: "range-bar-slider"
  }, [_c('label', {
    attrs: {
      "for": "selectionTolerance"
    }
  }, [_vm._v("Tolerance")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionTolerance),
      expression: "selectionTolerance"
    }],
    attrs: {
      "name": "selectionTolerance",
      "type": "range",
      "id": "selectionTolerance",
      "min": "0.1",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.selectionTolerance)
    },
    on: {
      "change": function($event) {
        return _vm.setSelectionTolerance($event)
      },
      "__r": function($event) {
        _vm.selectionTolerance = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-bar-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionTolerance),
      expression: "selectionTolerance"
    }],
    attrs: {
      "type": "number",
      "min": "0.1",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.selectionTolerance)
    },
    on: {
      "change": function($event) {
        return _vm.setBrushRadius($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectionTolerance = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.brushMode) ? _c('div', {
    staticClass: "range-bar"
  }, [_c('div', {
    staticClass: "range-bar-slider"
  }, [_c('label', {
    attrs: {
      "for": "brushRadius"
    }
  }, [_vm._v("Brush Radius")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brushRadius),
      expression: "brushRadius"
    }],
    attrs: {
      "name": "brushRadius",
      "type": "range",
      "id": "brushRadius",
      "min": "0.1",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.brushRadius)
    },
    on: {
      "change": function($event) {
        return _vm.setBrushRadius($event)
      },
      "__r": function($event) {
        _vm.brushRadius = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-bar-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brushRadius),
      expression: "brushRadius"
    }],
    attrs: {
      "type": "number",
      "min": "0.1",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.brushRadius)
    },
    on: {
      "change": function($event) {
        return _vm.setBrushRadius($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brushRadius = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "range-bar"
  }, [_c('div', {
    staticClass: "range-bar-slider"
  }, [_c('label', {
    attrs: {
      "for": "supportTransparency"
    }
  }, [_vm._v("Support Transparency")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportTransparency),
      expression: "supportTransparency"
    }],
    attrs: {
      "name": "supportTransparency",
      "type": "range",
      "id": "supportTransparency",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.supportTransparency)
    },
    on: {
      "input": function($event) {
        return _vm.setSupportTransparency($event)
      },
      "__r": function($event) {
        _vm.supportTransparency = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-bar-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportTransparency),
      expression: "supportTransparency"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.supportTransparency)
    },
    on: {
      "change": function($event) {
        return _vm.setSupportTransparency($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supportTransparency = $event.target.value
      }
    }
  })])]), _vm._v(" "), (this.isStrengthenSupp) ? _c('div', {
    staticClass: "range-bar"
  }, [_c('div', {
    staticClass: "range-bar-slider"
  }, [_c('label', {
    attrs: {
      "for": "StrengthenSupportTransparency"
    }
  }, [_vm._v("Strengthen Supp Transparency")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strengthenSupportTransparency),
      expression: "strengthenSupportTransparency"
    }],
    attrs: {
      "name": "StrengthenSupportTransparency",
      "type": "range",
      "id": "StrengthenSupportTransparency",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.strengthenSupportTransparency)
    },
    on: {
      "input": function($event) {
        return _vm.setSupportTransparency($event, true)
      },
      "__r": function($event) {
        _vm.strengthenSupportTransparency = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-bar-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strengthenSupportTransparency),
      expression: "strengthenSupportTransparency"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.strengthenSupportTransparency)
    },
    on: {
      "change": function($event) {
        return _vm.setSupportTransparency($event, true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.strengthenSupportTransparency = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-block center-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.$modal.show('modifycaution')
      }
    }
  }, [_vm._v("Generate supports")])]), _vm._v(" "), _c('div', {
    staticClass: "button-block center-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.resetFaces()
      }
    }
  }, [_vm._v("Reset selection")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.modifySupportsMode && _vm.isHasSupports && _vm.showDirectionSelection && _vm.isHasOptions),
      expression: "!modifySupportsMode && isHasSupports && showDirectionSelection && isHasOptions"
    }],
    staticClass: "left-panel"
  }, [(!(_vm.creatingJob || _vm.loading3JS)) ? _c('div', {
    staticClass: "buttons-block"
  }, [(_vm.nestedMode) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nestedPlate),
      expression: "nestedPlate"
    }],
    staticClass: "browser-default",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nestedPlate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.switchBuildPlate()
      }]
    }
  }, [_vm._l((_vm.nestedNames), function(plate, index) {
    return [_c('option', {
      key: plate,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(plate))])]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a3d btn btn-large no-wrap",
    on: {
      "click": function($event) {
        return _vm.viewer.reset()
      }
    }
  }, [_vm._v("Reset View")]), _vm._v(" "), (_vm.isHasSupports && !_vm.modifySupportsMode && _vm.isHasDistortionData) ? _c('button', {
    staticClass: "a3d btn btn-large no-wrap",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": _vm.modifyMode
    },
    on: {
      "click": function($event) {
        return _vm.toggleSupports()
      }
    }
  }, [_vm._v(_vm._s(_vm.showSupportsOutput ? 'Show distortion' : 'Show Support'))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSupportsOutput),
      expression: "!showSupportsOutput"
    }],
    staticClass: "second",
    staticStyle: {
      "flex-grow": "1",
      "margin": "15px 0"
    }
  }, [(!(_vm.creatingJob || _vm.loading3JS)) ? _c('div', {
    staticClass: "jobOptimization"
  }, [(_vm.jobOptimization) ? _c('div', {
    staticClass: "info-text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Optimization: ")]), _vm._v(_vm._s(_vm.jobOptimization) + "\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSupportsOutput),
      expression: "!showSupportsOutput"
    }],
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "left-panel__box",
    staticStyle: {
      "align-self": "flex-end",
      "padding": "16px",
      "margin-right": "15px"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn a3d inv",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        return _vm.viewer.applyNewLegendLimit()
      }
    }
  }, [_vm._v("Apply new legend limit")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn a3d inv",
    staticStyle: {
      "margin": "5px 0 0 0",
      "width": "100%"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        return _vm.viewer.resetLegendLimit()
      }
    }
  }, [_vm._v("\n              Reset legend limit\n            ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "left-panel__box"
  }, [(_vm.isBladeCanCrush) ? _c('div', {
    staticClass: "caution"
  }, [_vm._v(_vm._s(_vm.isBladeCanCrushMessage))]) : _vm._e(), _vm._v(" "), (_vm.isHasOptionsFull) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementOption),
      expression: "displacementOption"
    }],
    attrs: {
      "name": "displacementOption",
      "type": "radio",
      "id": "default-opt",
      "value": "default"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementOption, "default")
    },
    on: {
      "change": [function($event) {
        _vm.displacementOption = "default"
      }, function($event) {
        return _vm.switchDistortionOption('default')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-opt"
    }
  }, [_vm._v("Total distortion (post-support removal to stl)")])]) : _vm._e(), _vm._v(" "), (_vm.isHasOptionsFull) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementOption),
      expression: "displacementOption"
    }],
    attrs: {
      "name": "displacementOption",
      "type": "radio",
      "id": "removal-opt",
      "value": "removal"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementOption, "removal")
    },
    on: {
      "change": [function($event) {
        _vm.displacementOption = "removal"
      }, function($event) {
        return _vm.switchDistortionOption('removal')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "removal-opt"
    }
  }, [_vm._v("Distortion due to residual stress (post-support removal to as-built part)")])]) : _vm._e(), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementOption),
      expression: "displacementOption"
    }],
    attrs: {
      "name": "displacementOption",
      "type": "radio",
      "id": "on-opt",
      "value": "on"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementOption, "on")
    },
    on: {
      "change": [function($event) {
        _vm.displacementOption = "on"
      }, function($event) {
        return _vm.switchDistortionOption('on')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "on-opt"
    }
  }, [_vm._v("Distortion due to build process (as-built to stl)")])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel__box"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementDirection),
      expression: "displacementDirection"
    }],
    attrs: {
      "name": "displacementDirection",
      "type": "radio",
      "id": "z-dist",
      "value": "z"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementDirection, "z")
    },
    on: {
      "change": [function($event) {
        _vm.displacementDirection = "z"
      }, function($event) {
        return _vm.viewer.switchDistortion('z')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "z-dist"
    }
  }, [_vm._v("Z-Direction Displacement")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementDirection),
      expression: "displacementDirection"
    }],
    attrs: {
      "name": "displacementDirection",
      "type": "radio",
      "id": "y-dist",
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementDirection, "y")
    },
    on: {
      "change": [function($event) {
        _vm.displacementDirection = "y"
      }, function($event) {
        return _vm.viewer.switchDistortion('y')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "y-dist"
    }
  }, [_vm._v("Y-Direction Displacement")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementDirection),
      expression: "displacementDirection"
    }],
    attrs: {
      "name": "displacementDirection",
      "type": "radio",
      "id": "x-dist",
      "value": "x"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementDirection, "x")
    },
    on: {
      "change": [function($event) {
        _vm.displacementDirection = "x"
      }, function($event) {
        return _vm.viewer.switchDistortion('x')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "x-dist"
    }
  }, [_vm._v("X-Direction Displacement")])]), _vm._v(" "), (_vm.displacementDirectionN) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementDirection),
      expression: "displacementDirection"
    }],
    attrs: {
      "name": "displacementDirection",
      "type": "radio",
      "id": "n-dist",
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementDirection, "n")
    },
    on: {
      "change": [function($event) {
        _vm.displacementDirection = "n"
      }, function($event) {
        return _vm.viewer.switchDistortion('n')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "n-dist"
    }
  }, [_vm._v("Displacement normal to part surface")])]) : _vm._e()]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.legends > 0) ? _c('div', {
    staticClass: "legend-block"
  }, [_c('div', {
    staticClass: "inset-legend"
  }, [_c('div', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.currentPartName))]), _vm._v(" "), _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("Distortion [mm]")]), _vm._v(" "), _c('div', {
    staticClass: "inset-legend-wrp",
    attrs: {
      "id": "inset-legend-wrp"
    }
  })])]) : _vm._e()])])])], _vm._v(" "), (!_vm.isNxUser) ? _c('router-link', {
    staticClass: "a3d btn btn-large",
    staticStyle: {
      "position": "absolute",
      "top": "1em",
      "left": "1em"
    },
    attrs: {
      "to": {
        name: 'Dash'
      }
    }
  }, [_vm._v("Back")]) : _vm._e(), _vm._v(" "), (_vm.showOverlay) ? _c('div', {
    staticClass: "overlay"
  }) : _vm._e(), _vm._v(" "), _c('modal', {
    ref: "summarymodal",
    attrs: {
      "name": "summarymodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "75%"
    }
  }, [_c('job-summary', {
    attrs: {
      "config": _vm.config,
      "jobDescription": _vm.jobDescription,
      "submit": _vm.submitInput
    }
  })], 1), _vm._v(" "), _c('modal', {
    ref: "summarynestedmodal",
    attrs: {
      "name": "summarynestedmodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [(!_vm.isManualPlacement) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("Submit Nested Job?")]) : _c('div', [(_vm.platesErrors) ? _c('div', {
    staticClass: "title alert-title"
  }, [_vm._v("There are some errors on build plates. Submit anyway?")]) : (!_vm.platesConfig.length) ? _c('div', {
    staticClass: "title alert-title"
  }, [_vm._v("You should add plates first")]) : _c('div', {
    staticClass: "title"
  }, [_vm._v("Submit Nested Job?")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, _vm._l((_vm.platesConfig), function(plate, index) {
    return _c('div', {
      key: index,
      staticClass: "plate"
    }, _vm._l((plate), function(plateName, name) {
      return _c('div', {
        key: name
      }, [_c('div', {
        staticClass: "plate-title",
        style: (plateName.errors && 'color: red')
      }, [_vm._v(" Build " + _vm._s(name) + " ")]), _vm._v(" "), _vm._l((plateName), function(part, name) {
        return _c('div', {
          key: name
        }, [(name !== 'errors') ? _c('div', [_vm._v(_vm._s(name) + "  copies: " + _vm._s(part.length / 3))]) : _vm._e()])
      })], 2)
    }), 0)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    attrs: {
      "disabled": !_vm.platesConfig.length && _vm.isManualPlacement
    },
    on: {
      "click": function($event) {
        return _vm.submitInput()
      }
    }
  }, [_vm._v("Ok")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('summarynestedmodal')
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('modal', {
    ref: "modifycaution",
    attrs: {
      "name": "modifycaution",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Modifying supports jeopardizes build success. Modified support builds are at user's own risk.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.generateSupportStructures()
      }
    }
  }, [_vm._v("Modify")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('modifycaution')
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('modal', {
    ref: "dialoghelp",
    attrs: {
      "name": "dialoghelp",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "dialog-help"
  }, [_c('p', [_c('b', [_vm._v("Instructions")])]), _vm._v(" "), _c('p', [_vm._v(" The viewer allows the user to choose the unit, scaling factor and orientation of the part and start the AM simulation.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Choose the unit associated with the STL file.")]), _vm._v(" "), _c('li', [_vm._v("Choose the scaling factor of the part, e.g., scaling factor = 1.5 means the printed part is 150% of the orignal size of the STL.")]), _vm._v(" "), _c('li', [_vm._v("Change the part orientation by dragging the part or by entering the three Euler angles.")]), _vm._v(" "), _c('li', [_vm._v("After the scaling factor and orientation is chosen, uncheck \"Orient Model\" to generate support structures.")]), _vm._v(" "), _c('li', [_vm._v("To choose a different unit, scaling factor or part orientation, check \"Orient Model\" again.")]), _vm._v(" "), _c('li', [_vm._v("The user can reset the view by clicking \"Reset View\".")]), _vm._v(" "), _c('li', [_vm._v("After the unit, scaling factor and orientatoin are decided, click \"RUN JOB\" to start the job.")])]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('dialoghelp')
      }
    }
  }, [_vm._v("Ok")])])])]), _vm._v(" "), _c('modal', {
    ref: "zrotationmodal",
    attrs: {
      "name": "zrotationmodal",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "dialog-help"
  }, [_c('p', [_vm._v("WARNING: By setting the z rotation manually, you may not achieve the best possible density of parts, uncheck the box again to let AM Build Optimizer maximize your part density")]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.changeZRotation(true)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.changeZRotation(false)
      }
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('modal', {
    ref: "removeplatemodal",
    attrs: {
      "name": "removeplatemodal",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "dialog-help"
  }, [_c('p', [_vm._v("WARNING: There are some nested parts on this build plate. Remove plate anyway?")]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.removePlate(true)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.removePlate(false)
      }
    }
  }, [_vm._v("Cancel")])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Legend lower limit (mm): ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "legendLowerLimit"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Legend upper limit (mm): ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "legendUpperLimit"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-panel__box"
  }, [_c('p', [_c('label', {
    attrs: {
      "id": "distortionAtSelect"
    }
  }, [_vm._v("Distortion at select: ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25c81e86", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25c81e86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Viewer.vue
// module id = 475
// module chunks = 1